// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"28a91be3","455":"35210d38","977":"7a2110a9"}[chunkId] + ".chunk.js";
};